"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiTheme = void 0;
var styles_1 = require("@material-ui/core/styles");
/**
 * Alternative to MUI's createMuiTheme that doesn't log findDomNode warnings in StrictMode
 *
 * @see https://github.com/mui-org/material-ui/issues/13394
 */
exports.createMuiTheme = process.env.NODE_ENV === 'production'
    ? styles_1.createMuiTheme
    : styles_1.unstable_createMuiStrictModeTheme;
